import { render, staticRenderFns } from "./status-box.vue?vue&type=template&id=a3c72076"
import script from "./status-box.vue?vue&type=script&lang=js"
export * from "./status-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports